module.exports = __webpack_public_path__ + "static/pumpjack-c7c58c953093f035db3b3fcb301a064a.jpg";